import { DefaultTheme } from 'styled-components';

export const DarkTheme: DefaultTheme = {
    defaultSize: {
        small: '172px',
        medium: '496px',
        large: '896px',
        full: '100%',
    },
    defaultHeight: {
        medium: '36px',
    },
    device: {
        maxWidth: '1400px',
        minWidth: '768px',
        // mobile: 'screen and (max-width: 480px)',
        // tablet: 'screen and (min-width: 768px) and (max-width: 1024px)',
        tablet: 'screen and (max-width: 1024px)',
        desktop: 'screen and (min-width: 1024px)',
    },
    color: {
        background: '#18191F',
        box: '#2C2D33',
        boxCategory: '#36373E',
        tableCategory: '#36373E',
        select: '#344771',
        point: '#4585FF',
        point2: '#92C8D1',

        mainFont: '#F2F3F9',
        fontDisable: '#AAAAAA',
        placeholder: '#78797D',
        error: '#FF5C5C',

        borderDefault: '#3D3E45',
        borderActive: '#F2F3F9',
    },
    // bgColor: 'black',
    // containerBgColor: '#2f3640',
    // textColor: '#f5f6fa',
    // accentColor: '#8c7ae6',
    // labelTextColor: '#63A2AD',
    // titleBgColor: '#333333',
};

export const LightTheme: DefaultTheme = {
    defaultSize: {
        small: '172px',
        medium: '496px',
        large: '896px',
        full: '100%',
    },
    defaultHeight: {
        medium: '36px',
    },
    device: {
        maxWidth: '1400px',
        minWidth: '768px',
        // mobile: 'screen and (max-width: 480px)',
        // tablet: 'screen and (min-width: 768px) and (max-width: 1024px)',
        tablet: 'screen and (max-width: 1024px)',
        desktop: 'screen and (min-width: 1024px)',
    },

    color: {
        background: '#FAFAFA',
        box: '#FFFFFF',
        boxCategory: '#F5F5F5',
        tableCategory: '#f2f6fc',
        select: '#DEFCFF',
        point: '#0072CE',
        point2: '#63A2AD',

        mainFont: '#333333',
        fontDisable: '#65748D',
        placeholder: '#CCCCCC',
        error: '#D60303',

        borderDefault: '#DDDDDD',
        borderActive: '#333333',
    },

    // background: '#FAFAFA',
    // containerBackground: '#FFFFFF',
    // backgroundBox: '#F5F5F5',
    // backgroundTableHeader: '#f2f6fc',
    // accent: '#0072CE',
    // text: '#333333',
    // labelText: '#63A2AD',
    // disable: '#F4FAFF',

    // bgColor: '#FAFAFA',
    // titleBgColor: '#F5F5F5',
    // containerBgColor: '#FFFFFF',
    // textColor: '#333333',
    // labelTextColor: '#63A2AD',

    // #f2f6fc
    //#F4FAFF
};
export default LightTheme;
